import { appContext } from '@/context/appContext';
import { defaultVars } from '@/misc/defaultVars';

export function getShifterName() {
  return appContext.userData.profile.proxy.name ? appContext.userData.profile.proxy.name : defaultVars.shifter_name;
}
